import { buildContainsFilter, mergeFilters } from '@/ui/composites/grid/gridFilters';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';

export const buildPipelineSummaryInputs = ({
  isLatestMode,
  search,
  pipelineStatusFilters,
  tagFilters,
  selectedStartDay,
  selectedEndDay,
  rangeStartIso,
  rangeEndIso,
  previousRangeStartIso,
  previousRangeEndIso,
}: {
  isLatestMode: boolean;
  search: string;
  pipelineStatusFilters: GridQueryInput['filters'];
  tagFilters: GridQueryInput['filters'];
  selectedStartDay: string | null;
  selectedEndDay: string | null;
  rangeStartIso: string | null;
  rangeEndIso: string | null;
  previousRangeStartIso: string | null;
  previousRangeEndIso: string | null;
}): {
  summaryInput: {
    page: number;
    pageSize: number;
    sorts: [];
    filters: GridQueryInput['filters'];
    metricsStartDay?: string | undefined;
    metricsEndDay?: string | undefined;
  };
  previousSummaryInput: {
    page: number;
    pageSize: number;
    sorts: [];
    filters: GridQueryInput['filters'];
    metricsStartDay?: string | undefined;
    metricsEndDay?: string | undefined;
  } | null;
  summaryFiltersKey: string;
  previousSummaryFiltersKey: string;
} => {
  const summaryInput: {
    page: number;
    pageSize: number;
    sorts: [];
    filters: GridQueryInput['filters'];
    metricsStartDay?: string | undefined;
    metricsEndDay?: string | undefined;
  } = {
    page: 1,
    pageSize: 1,
    sorts: [] as [],
    filters: mergeFilters(buildContainsFilter('name', search), pipelineStatusFilters, tagFilters),
    metricsStartDay: selectedStartDay ?? rangeStartIso?.slice(0, 10) ?? undefined,
    metricsEndDay: selectedEndDay ?? rangeEndIso?.slice(0, 10) ?? undefined,
  };
  const previousSummaryInput: {
    page: number;
    pageSize: number;
    sorts: [];
    filters: GridQueryInput['filters'];
    metricsStartDay?: string | undefined;
    metricsEndDay?: string | undefined;
  } | null = isLatestMode
    ? null
    : {
        page: 1,
        pageSize: 1,
        sorts: [] as [],
        filters: mergeFilters(
          buildContainsFilter('name', search),
          pipelineStatusFilters,
          tagFilters,
        ),
        metricsStartDay: selectedStartDay
          ? undefined
          : (previousRangeStartIso?.slice(0, 10) ?? undefined),
        metricsEndDay: selectedEndDay
          ? undefined
          : (previousRangeEndIso?.slice(0, 10) ?? undefined),
      };

  return {
    summaryInput,
    previousSummaryInput,
    summaryFiltersKey: JSON.stringify({
      metricsStartDay: summaryInput.metricsStartDay ?? null,
      metricsEndDay: summaryInput.metricsEndDay ?? null,
      filters: summaryInput.filters,
    }),
    previousSummaryFiltersKey: previousSummaryInput
      ? JSON.stringify({
          metricsStartDay: previousSummaryInput.metricsStartDay ?? null,
          metricsEndDay: previousSummaryInput.metricsEndDay ?? null,
          filters: previousSummaryInput.filters,
        })
      : 'latest',
  };
};
